import { render, staticRenderFns } from "./TheAdminProfile.vue?vue&type=template&id=f4ae5c4e"
import script from "./TheAdminProfile.vue?vue&type=script&lang=js"
export * from "./TheAdminProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports